import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type { ConfluencePagePreviewPanelProps } from './ui/confluence-page-preview-panel';

export const confluencePagePreviewPanelEntryPoint: EntryPoint<
	EntryPointComponent<
		Record<string, never>,
		Record<string, never>,
		ConfluencePagePreviewPanelProps,
		Record<string, never>
	>,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "confluence-preview-panel-entrypoint" */ './ui/confluence-page-preview-panel/main'
			), { moduleId: "d73b44f1", modulePath: "../platform/packages/confluence/confluence-page-preview-panel/src/ui/confluence-page-preview-panel/main.tsx", priority: "interaction", moduleId: 'confluence-preview-panel-entrypoint',
		},
	),
	getPreloadProps: () => ({}),
});
